import { useMonarchRule } from "@/monarch/rules/MonarchRulesProvider";
import type {
  HeroPersonalizationV2Data,
  HeroPersonalizationV2Variant,
  HeroPersonalizationV2TestResult,
  UseHeroPersonalizationV2,
} from "./types";

const CUSTOM_RULE_ID = "heroPersonalizationV2";

/**
 * Hook for the homepage hero personalization experiment.
 * This experiment can return one of the following variants:
 * - homepageHeroV2Control: Current hero in production ("Bring your goals into focus")
 * - homepageHeroV2VariantA: "Learn anywhere with edX"
 * - homepageHeroV2VariantB: "Education for everyone"
 * - homepageHeroV2VariantC: "Level up your career"
 */
const useHeroPersonalizationV2: UseHeroPersonalizationV2 = () => {
  // Call the Monarch API to get the experiment result
  const { isLoading, value } = useMonarchRule<{
    data: HeroPersonalizationV2Data;
    variantCustomId: HeroPersonalizationV2Variant;
  }>(CUSTOM_RULE_ID, {});

  // If still loading or no value returned, return loading state
  if (isLoading || !value) {
    return {
      isLoading,
    } as HeroPersonalizationV2TestResult;
  }

  // Return the experiment result with proper typing
  return {
    isLoading: false,
    variant: value.variantCustomId,
    data: value.data,
  };
};

export default useHeroPersonalizationV2;
